import { render, staticRenderFns } from "./AccessPageFooter.vue?vue&type=template&id=1fdfe416"
import script from "./AccessPageFooter.vue?vue&type=script&lang=js"
export * from "./AccessPageFooter.vue?vue&type=script&lang=js"
import style0 from "./AccessPageFooter.vue?vue&type=style&index=0&id=1fdfe416&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports